/**
 * DataGrid cell that renders a row of LinkChips (e.g. rulesets, properties).
 * Styling, tooltips, and hrefs come from each chip's LinkChipType.
 */
import React from "react";
import { LinkChip, LinkChipItem, LinkChipType } from "components/LinkChip";
import { ChipCellContainer } from "./ChipCellContainer";

export type MultiChipCellProps = {
  readonly chipType: LinkChipType;
  readonly chipItems: readonly LinkChipItem[] | null | undefined;
};

export function MultiChipCell({
  chipType,
  chipItems: items,
}: MultiChipCellProps) {
  if (!items?.length) {
    return <ChipCellContainer />;
  }

  return (
    <ChipCellContainer>
      {items.map((chipInfo) => (
        <LinkChip
          key={chipInfo.id}
          chipType={chipType}
          id={chipInfo.id}
          name={chipInfo.name}
        />
      ))}
    </ChipCellContainer>
  );
}
